module.exports = __webpack_public_path__ + "static/media/placement-training.cdcc00dd.svg";